export class SetLeaderboardNickname {
  static readonly type = '[LeaderboardNickname] Set Leaderboard Nickname';
  constructor(public payload: { nickname: string }) {}
}
